import { sendGetRequest, sendPostRequest } from '@/helper/requests'
import { MENDELEEV_HOST } from "@/helper/consts"
import mendeleev from "@/urls/mendeleev"
import { useCookies } from "vue3-cookies"
import store from "@/store"
const { cookies } = useCookies()

function get_domain () {
  /*
  *
   */
  // if (process.env.VUE_APP_COOKIE_DOMAIN !== undefined) {
  //   return process.env.VUE_APP_COOKIE_DOMAIN
  // } else {
  //   return null
  // }
}

export function clear_stores () {
  /*
  * Очистка всех используемых стораджей относящихся непосредсвтенно к браузеру.
  * На данный момент это localstorage и cookie
  */
  localStorage.removeItem('user-token') // clear your user's token from localstorage
  localStorage.removeItem('username')
  localStorage.removeItem('user-uid')
  const domain = get_domain()
  cookies.remove("mendeleevcard", null, domain)
  cookies.remove("mendeleevcard", null, 'моямк.рф')
}

function set_local_store (token, username, uid) {
  /*
  * Заполняем локальное хранилище
   */
  localStorage.setItem('user-token', token)
  localStorage.setItem('username', username)
  localStorage.setItem('user-uid', uid)
}

function set_cookie_store (token, username, uid) {
  /*
  * Заполняем кукисы
   */
  cookies.remove("mendeleevcard", null, get_domain()) // удалим старый
  cookies.set(
    'mendeleevcard',
    {
      userToken: token,
      userName: username,
      userUid: uid,
    },
    "3y",
    null,
    get_domain(),
    null
  )
}

export function set_stores (token, username, uid) {
  /*
  * Сохранения в стораджи браузера нужных параметров, для того что бы они сохранялись от входа до входа
   */
  set_cookie_store(token, username, uid)
  set_local_store(token, username, uid)
}

// function set_stores (token, username, uid) {
//   /*
//   * Сохранения в стораджи браузера нужных параметров, для того что бы они сохранялись от входа до входа
//    */
//   set_cookie_store(token, username, uid)
//   set_local_store(token, username, uid)
// }

const state = {
  uid: null,
  token: null,
  status: null,
  error: null,
  username: null,
  last_check: null,
  need_change_password: false,
  loading: false,
  user_status: null,
  user_status_error: null,
}

const getters = {
  getUsername: state => state.username,
  getUserStatus: state => state.user_status,
  getToken: state => state.token,
  hasCookie: state => () => {
    return cookies.isKey('mendeleevcard')
  },
  isLoadingAlive: state => state.loading,
  isCookieLoaded: state => !!state.token,
  isAuthenticated: state => state.token !== null,
  isNeedChangePassword: state => state.need_change_password,
  isCheckExpired: state => () => {
    return (new Date() - state.last_check) > (60 * 1000)
  },
}

const actions = {
  LOAD_FROM_COOKIE: ({ commit }) => {
    const userMUCTR = cookies.get("mendeleevcard")
    if (userMUCTR !== undefined && userMUCTR !== null) {
      commit('SET_TOKEN', userMUCTR.userToken)
      commit('SET_USERNAME', userMUCTR.userName)
      commit('SET_UID', userMUCTR.userUid)
      set_stores(userMUCTR.userToken, userMUCTR.userName, "")
    }
  },

  CHECK_USER_STATUS: ({ commit }, { finalizer = () => {}, catcher = () => {} }) => {
    sendGetRequest(
      `${MENDELEEV_HOST}user/profile/status/`, (data) => {
        commit('SET_USER_STATUS', data)
        finalizer()
      }, (error) => {
        commit('SAVE_USER_ERROR', error)
        catcher()
      }
    )
  },

  AUTH_LOGOUT: ({ commit }, { finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.AUTH.LOGOUT()
    sendPostRequest(
      url,
      {},
      () => {
        commit('AUTH_LOGOUT')
        clear_stores()
        finalizer()
      },
      (err) => {
        clear_stores()
        commit('AUTH_ERROR', err.error)
        commit('SET_NOT_LOADING')
        catcher()
      }
    )
  },

  CHECK_TOKEN_ALIVE: ({ commit, dispatch, getters }) => {
    commit('SET_LOADING')
    return new Promise((resolve, reject) => {
      if (getters.hasCookie) {
        if (!getters.isCookieLoaded) {
          dispatch('LOAD_FROM_COOKIE')
        }
        fetch(
          `${MENDELEEV_HOST}authenticate/token/alive/`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: getters.getToken }),
            method: 'POST'
          }
        ).then(resp => {
          if (!resp.ok) {
            store.commit('urls/setNotLoadInstance')
            clear_stores()
            commit('SET_NOT_LOADING')
            reject(Error(resp.statusText))
          } else {
            return resp.json()
          }
        }).then(json => {
          if (json.alive === false) {
            clear_stores()
            commit('AUTH_LOGOUT').then(() => {
              reject(json)
            })
          } else {
            commit('SET_NEED_CHANGE_PASSWORD', json.need_change_password)
            commit('SET_CHECK_TIME')
            commit('SET_NOT_LOADING')
            resolve()
          }
        }).catch(error => {
          if (error.toString().includes('Failed to fetch')) {
            store.commit('urls/setNotLoadInstance')
          }
          clear_stores()
          commit('SET_NOT_LOADING')
          reject(error)
        })
      } else {
        commit('SET_NOT_LOADING')
        // eslint-disable-next-line
        reject()
      }
    })
  },

  LOGIN_AS_USER: ({ commit, dispatch }, { url, user, finalizer = () => {}, catcher = () => {} }) => {
    url = mendeleev.AUTH.LOGIN()
    sendPostRequest(
      url,
      user,
      (data) => {
        // commit('AUTH_LOGOUT')
        // clear_stores()
        set_stores(data.token, user.email, "")
        commit('AUTH_SUCCESS', { token: data.token, username: user.email, uid: "" })
        commit('urls/clearUrls', null, { root: true })
        finalizer(data)
      },
      (error) => {
        catcher(error)
      }
    )
  },

  SCIENCE_ID_OAUTH_REDIRECT: ({ commit, dispatch }, { url, finalizer = () => {}, catcher = () => {} }) => {
    url = mendeleev.AUTH.SCIENCE_ID.OAUTH_REDIRECT()
    sendGetRequest(
      url,
      (data) => {
        finalizer(data)
      },
      (error) => {
        catcher(error)
      }
    )
  },
  SCIENCE_ID_OAUTH_LOGIN: ({ commit, dispatch }, { url, token, finalizer = () => {}, catcher = () => {} }) => {
    url = mendeleev.AUTH.SCIENCE_ID.OAUTH_LOGIN()
    sendPostRequest(
      url, token,
      (data) => {
        finalizer(data)
      },
      (error) => {
        catcher(error)
      }
    )
  }
}

const mutations = {
  AUTH_LOGOUT: (state) => {
    state.status = 'logout'
    state.error = null
    state.token = null
    state.uid = null
    state.username = null
    state.last_check = null
    state.need_change_password = false
  },
  AUTH_SUCCESS: (state, { token, username, uid }) => {
    state.status = 'success'
    state.token = token
    state.username = username
    state.uid = uid
  },
  SET_CHECK_TIME: (state) => {
    state.last_check = new Date()
  },
  CLEAR_CHECK_TIME: (state) => {
    state.last_check = null
  },
  SET_NEED_CHANGE_PASSWORD: (state, need_change) => {
    state.need_change_password = need_change
  },
  CLEAR_ERROR: (state) => {
    state.status = ''
    state.error = ''
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    localStorage.setItem('user-token', token)
  },
  SET_USERNAME: (state, username) => {
    state.username = username
    localStorage.setItem('username', username)
  },
  SET_UID: (state, uid) => {
    state.uid = uid
    localStorage.setItem('user-uid', uid)
  },
  SET_LOADING: (state) => {
    state.loading = true
  },
  SET_NOT_LOADING: (state) => {
    state.loading = false
  },
  SET_USER_STATUS: (state, value) => {
    state.user_status = value
  },
  SAVE_USER_ERROR: (state, value) => {
    state.user_status_error = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
